import { Account, Activity } from "common";
import { ReactNode, createContext, useContext, useState } from "react";

export interface StoreState {
  activityList: Activity[];
  accounts: Account[];
}

export interface Store {
  state: StoreState;
  setState: (transformer: (state: StoreState) => StoreState) => void;
}

const StoreContext = createContext<Store>({
  state: {
    activityList: [],
    accounts: [],
  },
  setState: () => {},
});

export const StoreProvider = ({ children }: { children: ReactNode }) => {
  const [storeState, setStoreState] = useState<StoreState>({
    activityList: [],
    accounts: [],
  });
  return (
    <StoreContext.Provider
      value={{
        state: storeState,
        setState: setStoreState,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => {
  return useContext(StoreContext);
};
